import React from 'react';
import { ButtonGroup, Container, Paper, TextField, Typography } from '@mui/material';
import TableCustom from '../../components/Table/TableCustom';
import useListPage from './useListPage';
import DetailsBanner from '../../components/Banner/DetailsBanner';
import Shimmer from '../../components/Shimmer/Shimmer';
import Grid from '@mui/material/Unstable_Grid2';
import ButtonCustom from '../../components/Button/ButtonCustom';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import SelectAgentModal from './SelectAgentModal';
import TableShimmer from '../../components/Shimmer/TableShimmer';

const ListPage = () => {

  const {
    tbColumns,
    tbItems,
    isLoad,
    searchFromTable,
    btnAction,
    searchText,
    filteredTbItems,
    openModal,
    setOpenModal,
    isHQ
  } = useListPage();



  return (
    <>

      <Container maxWidth="xxl" sx={{ mb: 4 }}>

        <Grid container >
          
          {/* <Grid md={2} xs={12} sx={{ borderRight: { sm: 'none', md: '1px solid' }, borderColor: { sm: 'none', md: 'divider' }, pt: 4 }}>
            <DetailsBanner showDetails={{ user: true, transaction: false }} />
          </Grid> */}

          <Grid md={12} sm={12} sx={{ pl: { md: 2 }, pt: 4 }}>
            <Typography variant="h6" gutterBottom sx={{ textAlign: 'center', mb: 4 }}>
              <strong>LIST OF FILLED OUT FORMS</strong>
            </Typography>
            <Grid container justifyContent="flex-end" sx={{ mb: 1 }}>
            
              {/* <Grid xs={6} sx={{ mb: 1 }}>
                  <ButtonCustom
                    variant={'contained'}
                    label={"Create"}
                    endIcon={<AddOutlinedIcon />}
                    onClickBtn={btnAction.handleCreate}
                  />
                  {isHQ && 
                    <ButtonCustom
                      variant={'text'}
                      label={"Create for other agent"}
                      endIcon={<AddOutlinedIcon />}
                      onClickBtn={btnAction.handleCreateForOthers}
                    />
                  }
              </Grid> */}
              <Grid xs={12} md={12} sx={{ textAlign: 'right' }}>
                <TextField
                  label="Search"
                  onChange={(e) => searchFromTable(e)}
                  placeholder='Minimum of 3 characters'
                  fullWidth
                />
              </Grid>
            </Grid>
            {isLoad ? (
              <TableCustom
                columns={tbColumns}
                rows={searchText ? filteredTbItems : tbItems}
              />
            ) : (
              <TableShimmer />
            )}
          </Grid>
        </Grid>
      </Container>

      <SelectAgentModal
        openModal={openModal}
        setOpenModal={setOpenModal}
      />

    </>
  )

}

export default ListPage;